<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ssa_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ssa_emname">
            <label class="weui-form-preview__label">{{customLabel.ssa_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.ssa_emname}}
              <!-- <call-mobile :em-id="form.main.os_emid"></call-mobile> -->
            </span>
          </div>
          <div class="weui-form-preview__item" slot="em_sex">
            <label class="weui-form-preview__label">{{customLabel.em_sex || "性别"}}</label>
            <span class="weui-form-preview__value">{{form.main.em_sex}}</span>
          </div>
          <div class="weui-form-preview__item" slot="em_xl">
            <label class="weui-form-preview__label">{{customLabel.em_xl || "学历"}}</label>
            <span class="weui-form-preview__value">{{form.main.em_xl}}</span>
          </div>
          <div class="weui-form-preview__item" slot="em_entry_time">
            <label class="weui-form-preview__label">{{customLabel.em_entry_time || "入职时间"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.em_entry_time}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_department_old">
            <label class="weui-form-preview__label">{{customLabel.ssa_department_old || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_department_old}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_position_old">
            <label class="weui-form-preview__label">{{customLabel.ssa_position_old || "岗位"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_position_old}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_positionlevel_old">
            <label class="weui-form-preview__label">{{customLabel.ssa_positionlevel_old || "岗位等级"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_positionlevel_old}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_wage_old">
            <label class="weui-form-preview__label">{{customLabel.ssa_wage_old || "薪资"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_wage_old}}</span>
          </div>
        </custom-layout>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.ssa_type != '其他'" slot="ssa_type">
            <label class="weui-form-preview__label">{{customLabel.ssa_type || "申报类别"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_type}}</span>
          </div>
          <div class="weui-form-preview__item" v-else slot="ssa_othertext">
            <label class="weui-form-preview__label">{{customLabel.ssa_othertext || "申报类别"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_othertext}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">调后岗位/薪资</div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ssa_department_new">
            <label class="weui-form-preview__label">{{customLabel.ssa_department_new || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_department_new}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_position_old">
            <label class="weui-form-preview__label">{{customLabel.ssa_position_old || "岗位"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_position_old}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_positionlevel_new">
            <label class="weui-form-preview__label">{{customLabel.ssa_positionlevel_new || "岗位等级"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_positionlevel_new}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_wage_new">
            <label class="weui-form-preview__label">{{customLabel.ssa_wage_new || "薪资"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_wage_new}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_vailddate">
            <label class="weui-form-preview__label">{{customLabel.ssa_vailddate || "生效日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.ssa_vailddate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ssa_remark">
            <label class="weui-form-preview__label">{{customLabel.ssa_remark || "调整原因"}}</label>
            <span class="weui-form-preview__value">{{form.main.ssa_remark}}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.ssa_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <!-- <router-link
        :to="'/oa/seal_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link> -->
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <!-- <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a> -->
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
// import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    // CallMobile
  },
  data() {
    return {
      baseUrl: "/api/hr/salarysetchangeapply",
      codeField: "ssa_code",
      statusField: "ssa_statuscode",
      caller: "SalarySetChangeApply",
      xtype: "hr-salarysetchange-formpanel",
    };
  }
};
</script>